import { useState } from "react";

import LoginUsingOTP from "./LoginUsingOTP";
import CreateAccountUsingPhone from "./CreateAccountUsingPhone";
import ForgotPassword from "./ForgotPassword";
import { getCountryCode } from "../../lib";

export default function OTPLogin({
  hideChildCode,
  setloginType,
  loginType,
}: {
  hideChildCode: boolean;
  loginType: "child_code" | "otp";
  setloginType: (value: "child_code" | "otp") => void;
}) {
  const [path, setPath] = useState<"login" | "create" | "forgot">("login");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState(
    getCountryCode() == "US" ? "+1" : "+91"
  );

  return (
    <>
      {path == "login" && (
        <LoginUsingOTP
          loginType={loginType}
          setloginType={setloginType}
          hideChildCode={hideChildCode}
          phoneNumber={phoneNumber}
          countryCode={countryCode}
          setPhoneNumber={setPhoneNumber}
          setCountryCode={setCountryCode}
          onForgot={() => setPath("forgot")}
          onSignUp={() => setPath("create")}
        />
      )}
      {path == "create" && (
        <CreateAccountUsingPhone onLogin={() => setPath("login")} />
      )}
      {path == "forgot" && (
        <>
          <ForgotPassword
            phoneNumber={phoneNumber}
            countryCode={countryCode}
            setPhoneNumber={setPhoneNumber}
            setCountryCode={setCountryCode}
            onSuccess={() => setPath("login")}
            onClose={() => setPath("login")}
          />
        </>
      )}
    </>
  );
}
